import { useDispatch, useSelector } from 'react-redux'

import {
  DragNDropFileUploader,
  IDragNDropFileUploaderProps,
  IFileSettings,
} from 'core-components/library/dragNDropFileUploader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'
import { selectFlexSettings } from 'core-components/sitebuilder/store/selectors/selectFlexSettings'
import { setFlexSettings } from 'core-components/sitebuilder/store/siteBuilderSlice'

interface ISettingsImportModal {
  visible: boolean
  onClose: () => void
  storageKey: string
  onSave: (newSettings: IFlexLayout) => void
}

export const SettingsImportModal = ({
  visible,
  onClose,
  storageKey,
  onSave,
}: ISettingsImportModal) => {
  const dispatch = useDispatch()
  const flexSettings = useSelector(selectFlexSettings)
  const changeFileLoader = (filesInfo: IFileSettings[]) => {
    const reader = new FileReader()
    reader.onload = async (e: any) => {
      const importSettings = async (settings: IFlexLayout) => {
        const newSettings = JSON.parse(JSON.stringify(settings))
        const newFlexSettings = {
          ...flexSettings,
          [`${storageKey}`]: newSettings,
        }
        dispatch(setFlexSettings(newFlexSettings))
        onSave(newSettings)
      }

      try {
        const result = JSON.parse(e.target.result || '{}')
        await importSettings(result)
      } catch (e) {
        console.log(e)
      }
    }
    reader.readAsText(filesInfo[0].file)
  }

  return (
    <ModalDialog<IDragNDropFileUploaderProps>
      size={'sm'}
      show={visible}
      content={(dialogProps) => (
        <DragNDropFileUploader
          {...dialogProps}
          changeFileLoader={(filesInfo) => {
            dialogProps.closeModal()
            dialogProps.changeFileLoader(filesInfo)
          }}
        />
      )}
      onClose={onClose}
      contentProps={{
        changeFileLoader,
      }}
    />
  )
}
